import type { FC, ReactNode} from 'react';
import { createContext, useEffect, useState } from 'react';
import { useApi } from '../../hooks';
import type { ClientSettings } from '../../typings/configuration.types';
import { setClientSettings as setWindowClientSettings } from '../../utils/windowGlobals';

export const Context = createContext<ClientSettings | null>(null);

interface Props {
    children: ReactNode;
}

export const Provider: FC<Props> = ({ children = undefined }) => {
    const [clientSettings, setClientSettings] = useState({});
    const API = useApi();

    useEffect(() => {
        API.getClientSettings()
            .then((data) => {
                setClientSettings(data);
                setWindowClientSettings(data);
            })
            .catch(() => {
                // In this case we'll just carry on as normal and render buttons depending only on experiments values
            });
    }, []);

    return <Context.Provider value={clientSettings as ClientSettings}>{children}</Context.Provider>;
};
